module.exports = __webpack_public_path__ + "static/media/telephone-receiver.8dd34c93.png";